/**
 * Intel HEX format parser for microcontroller flashing.
 * Converts Intel HEX string/buffer into a contiguous Uint8Array.
 */

export function parseIntelHex(hexString: string): Uint8Array {
  const lines = hexString.split(/\r?\n/);
  let totalSize = 0;
  const blocks: { address: number; data: Uint8Array }[] = [];
  let upperAddress = 0;

  for (const line of lines) {
    if (!line.startsWith(':')) continue;
    
    const byteCount = parseInt(line.substring(1, 3), 16);
    const address = parseInt(line.substring(3, 7), 16);
    const recordType = parseInt(line.substring(7, 9), 16);
    const dataString = line.substring(9, 9 + byteCount * 2);
    const data = new Uint8Array(byteCount);
    for (let i = 0; i < byteCount; i++) {
        data[i] = parseInt(dataString.substring(i * 2, i * 2 + 2), 16);
    }

    if (recordType === 0) { // Data record
      const fullAddress = (upperAddress << 16) | address;
      blocks.push({ address: fullAddress, data });
      totalSize = Math.max(totalSize, fullAddress + byteCount);
    } else if (recordType === 4) { // Extended Linear Address Record
      upperAddress = (data[0] << 8) | data[1];
    } else if (recordType === 1) { // End of File
      break;
    }
  }

  // Find min address to avoid massive allocation if origin is high
  let minAddress = Infinity;
  for (const block of blocks) {
    minAddress = Math.min(minAddress, block.address);
  }

  if (minAddress === Infinity) return new Uint8Array(0);

  const buffer = new Uint8Array(totalSize - minAddress);
  for (const block of blocks) {
    buffer.set(block.data, block.address - minAddress);
  }

  return buffer;
}
